import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Critical failure: Root element unresolvable.');

const root = ReactDOM.createRoot(rootElement);
// StrictMode eradicated to stabilize the WebGL GPU rendering pipeline
root.render(<App />);
